export const messages = {
  labels: {
    comorbidityDiagnosisDate: {
      id: 'treatmentSummary.Groups.Comorbidity.ComorbidityDiagnosisDate',
      defaultMessage: 'Onset Date: ',
    },
    status: {
      id: 'treatmentSummary.Groups.Comorbidity.Status',
      defaultMessage: 'Condition Active?: ',
    },
    providerName: {
      id: 'treatmentSummary.Groups.Comorbidity.ProviderName',
      defaultMessage: 'Care Provider: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.Comorbidity.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
